import helpModal from './help-modal/help-modal.component';
import { getTopic, getTopicForState, listTopics } from './content';
import { getTopicAccess } from './content/access';

class HelpService {
  constructor($uibModal, $state, AuthenticationService) {
    'ngInject';
    this.$uibModal = $uibModal;
    this.$state = $state;
    this.auth = AuthenticationService;
  }

  canAccessTopic(topicOrId) {
    const topic = typeof topicOrId === 'string' ? getTopic(topicOrId) : topicOrId;
    if (!topic) {
      return false;
    }

    const access = getTopicAccess(topic.id);

    if (access.requireTrackLeave) {
      if (!this.auth.user || !this.auth.hasTrackLeave()) {
        return false;
      }
    }

    const permissions = access.permissions || [];
    if (!permissions.length) {
      // No permission list means available to any authenticated user
      return !!this.auth.user;
    }

    return permissions.some((permission) => this.auth.hasPermission(permission));
  }

  getTopic(topicId) {
    const topic = getTopic(topicId);
    if (!topic || !this.canAccessTopic(topic)) {
      return null;
    }
    return topic;
  }

  getTopicForState(stateName) {
    const topic = getTopicForState(stateName || (this.$state.current && this.$state.current.name));
    if (!topic || !this.canAccessTopic(topic)) {
      return null;
    }
    return topic;
  }

  hasTopic(topicId) {
    return !!this.getTopic(topicId);
  }

  hasTopicForCurrentState() {
    return !!this.getTopicForState();
  }

  listTopics() {
    return listTopics().filter((topic) => this.canAccessTopic(topic));
  }

  listTopicsByCategory() {
    return this.listTopics().reduce((groups, topic) => {
      const category = topic.category || 'General';
      if (!groups[category]) {
        groups[category] = [];
      }
      groups[category].push(topic);
      return groups;
    }, {});
  }

  getRelatedTopics(topic) {
    if (!topic || !topic.related) {
      return [];
    }
    return topic.related
      .map((relatedId) => this.getTopic(relatedId))
      .filter(Boolean);
  }

  /**
   * Opens contextual help for a topic id, or the current ui-router state when omitted.
   * Pass { browse: true } to show the topic browser (Getting Started hub).
   * Topics the user cannot access are skipped.
   */
  open(topicId, options = {}) {
    const browse = !!options.browse;
    let topic = null;

    if (topicId) {
      topic = this.getTopic(topicId);
    } else if (!browse) {
      topic = this.getTopicForState();
    }

    if (!topic) {
      topic = this.getTopic('overview') || this.listTopics()[0] || null;
    }

    if (!topic) {
      return Promise.resolve(null);
    }

    const showBrowser = browse || topic.id === 'overview';

    const modalInstance = this.$uibModal.open(Object.assign({}, helpModal, {
      resolve: {
        helpTopic: () => topic,
        showBrowser: () => showBrowser
      }
    }));

    return modalInstance.result.catch(() => null);
  }

  openForCurrentState() {
    return this.open();
  }

  openBrowser() {
    return this.open('overview', { browse: true });
  }
}

export default HelpService;



// WEBPACK FOOTER //
// ./client/help/help.service.js